import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskLines({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "div" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
          <motion.span
            className={"block will-change-transform " + lineClassName}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.14 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <FadeUp className={`flex flex-col gap-5 ${alignCls}`}>
      <span className="flex items-center gap-3">
        <span className="shimmer-line w-10" />
        <span className="text-[11px] uppercase tracking-[0.34em] font-semibold text-[#D4AF37]">
          {eyebrow}
        </span>
        <span className="shimmer-line w-10" />
      </span>
      <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.04] text-[#FAF6F0]">
        {title}
      </h2>
      {sub && <p className="max-w-2xl text-[15px] sm:text-base font-light leading-relaxed text-[#A39791]">{sub}</p>}
    </FadeUp>
  );
}
